<template>
  <div v-if="operation.certifications && operation.certifications.length > 0" class="col-12 col-lg-6 d-flex flex-column p-3">
    <OperationsTitle name="Certifications" />
    <DownloadableFileList :documents="operation.certifications" :is-downloadable="true" :is-certiciations="true" />
  </div>
</template>

<script>
import OperationsTitle from "../common/OperationsTitle.vue";
import DownloadableFileList from "@/components/documents/DownloadableFileList.vue";

export default {
  name: "OperationsCertifications",
  components: {
    OperationsTitle,
    DownloadableFileList,
  },
  props: {
    operation: { type: Object, requried: true },
  },
};
</script>

<style scoped></style>
